module.exports = __webpack_public_path__ + "asset/img/defaultMember.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/images/defaultMember.png
// module id = 471
// module chunks = 1 2 3 4 5 7 9 11 12 15 17 19 22 33 35 37 54